import styled from "@emotion/styled"
import {
  StyledCard as CommonStyledCard,
  StyledImageBox as CommonStyledImageBox,
  StyledCardInfo as CommonStyledCardInfo,
  StyledCardTitle as CommonStyledCardTitle,
  StyledCardSubtitle as CommonStyledCardSubtitle,
  StyledPartnerLogo as CommonStyledPartnerLogo,
  StyledPartnerTitle as CommonStyledPartnerTitle,
  StyledPartnerDetails as CommonStyledPartnerDetails,
  StyledPartnerTitleText as CommonStyledPartnerTitleText,
  StyledPACMultiplier as CommonStyledPACMultiplier,
} from "../index.styles"

export const StyledCard = styled(CommonStyledCard)``

export const StyledDoublePacsTooltip = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 0;

  .checkoutSummaryCard {
    box-shadow: 0 0 0.75rem rgba(0, 0, 0, 0.15);
    opacity: 1 !important;

    @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
      width: 13.75rem;
    }
    @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
      width: unset;
    }
  }
`

export const StyledImageBox = styled(CommonStyledImageBox)``

export const StyledCardInfo = styled(CommonStyledCardInfo)``

export const StyledCardTitle = styled(CommonStyledCardTitle)``

export const StyledCardSubtitle = styled(CommonStyledCardSubtitle)``

export const StyledPartnerLogo = styled(CommonStyledPartnerLogo)``

export const StyledPartnerTitle = styled(CommonStyledPartnerTitle)``

export const StyledPartnerDetails = styled(CommonStyledPartnerDetails)``

export const StyledPartnerTitleText = styled(CommonStyledPartnerTitleText)``

export const StyledPACMultiplier = styled(CommonStyledPACMultiplier)``
